import "./UmSpUserInfo.scss";

import React from "react";
import { bemBlock } from "@ngd-web/lv-utils/ui/bemHelper";
import { cl } from "@ngd-web/lv-utils/ui/classNames";
import { IState } from "@common/state/IState";
import { useObjectSelector } from "@common/utils/selectors/useSelectorEx";
import {
    umSpPageAuthSelector,
    umSpPageSchemeSelector,
    umSpPageStateSelector,
} from "../_shared/selectors";
import { ObjectPropertyType } from "@common/model/api/Datasources/ObjectPropertyType";
import { ProfileIconComponent } from "@common/icons/ProfileIconComponent";
import { UmSpDcFullNameElement } from "../_shared/dynamicContent/UmSpDcFullNameElement";
import { TSubscriptionPreferencesMode } from "../subscriptionPreferences/SubscriptionPreferencesModel";

const selector = (s: IState) => {
    const auth = umSpPageAuthSelector(s);
    const scheme = umSpPageSchemeSelector(s);
    const mode = umSpPageStateSelector(s)?.mode ?? "identify";
    if (!auth || !scheme)
        return { mode, email: "user@mail", phone: "user.phone" };

    const emailProp = scheme.Properties.find(
        p => p.Type == ObjectPropertyType.Email
    );
    const mobileProp = scheme.Properties.find(
        p => p.Type == ObjectPropertyType.Mobile
    );
    const phoneProp = scheme.Properties.find(
        p => p.Type == ObjectPropertyType.Phone
    );

    mobileProp.Name;

    auth.user;
    return {
        mode,
        email: emailProp ? auth.user[emailProp.Name] : "",
        phone:
            mobileProp && auth.user[mobileProp.Name]
                ? auth.user[mobileProp.Name]
                : phoneProp
                ? auth.user[phoneProp.Name]
                : "",
    };
};

const allowedModes: TSubscriptionPreferencesMode[] = [
    "edit",
    "saving",
    "saved",
];

export function UmSpUserInfoComponent({ className }) {
    const [bl, el] = bemBlock("UmSpUserInfo");
    const { mode, email, phone } = useObjectSelector(selector);

    return !allowedModes.includes(mode) ? null : (
        <div className={cl(bl(), className)}>
            <div className={el("title")}>
                <div className={el("user-icon")}>
                    <ProfileIconComponent />
                </div>

                <UmSpDcFullNameElement className={el("name")} />
            </div>

            <div className={el("contacts")}>
                <div>{email}</div>
                <div>{phone}</div>
            </div>
        </div>
    );
}
